/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Drawer_Inherit_EnabledInputs */



/**
* | output |
* | --- |
* | "Falls back to the everyone value: enabled." |
*
* @param {Rights_Tools_Drawer_Inherit_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_drawer_inherit_enabled = /** @type {((inputs?: Rights_Tools_Drawer_Inherit_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Drawer_Inherit_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fällt auf den „Alle“-Wert zurück: aktiviert.")
	return /** @type {LocalizedString} */ ("Falls back to the everyone value: enabled.")
});